export default __webpack_public_path__ + "static/media/comedora-centro-nuevo-transparent-flipped.c9e46fd2.png";